/* istanbul ignore next */
const ACTIONS = {
    FETCH_GIFT_CARD_REDEMPTION_DATA_SUCCESS: 'FETCH_GIFT_CARD_REDEMPTION_DATA_SUCCESS',
    FETCH_GIFT_CARD_REDEMPTION_DATA_ERROR: 'FETCH_GIFT_CARD_REDEMPTION_DATA_ERROR',
    FORM_SUBMIT: 'FORM_SUBMIT',
    FORM_SUBMIT_SUCCESS: 'FORM_SUBMIT_SUCCESS',
    FORM_SUBMIT_FAILURE: 'FORM_SUBMIT_FAILURE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    fetchGiftCardRedemptionDataSuccess(response) {
        return {
            type: ACTIONS.FETCH_GIFT_CARD_REDEMPTION_DATA_SUCCESS,
            payload: {
                response
            }
        };
    },

    fetchGiftCardRedemptionDataError(response) {
        return {
            type: ACTIONS.FETCH_GIFT_CARD_REDEMPTION_DATA_ERROR,
            payload: {
                response
            }
        };
    }

};

export default {...ACTIONS, ...ACTION_CREATORS};
